import React from 'react';
import './Order.css';
import CurrencyFormat from "react-currency-format";
import CheckoutProduct from '../CheckoutProduct/CheckoutProduct';


function Order() {
    return (
        <div className='order'>
            <h2>Order</h2>
        </div>
    )    
}

export default Order;